import { render, staticRenderFns } from "./menu-add-or-update.vue?vue&type=template&id=77273414&"
import script from "./menu-add-or-update.vue?vue&type=script&lang=js&"
export * from "./menu-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./menu-add-or-update.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports